import React from 'react';
import type { VersusTeam } from '../game/types';

interface VersusBuzzerProps {
  team: VersusTeam;
  activeTeam: VersusTeam | null;
  onBuzz: (team: VersusTeam) => void;
  id?: string;
  className?: string;
}

export const VersusBuzzer: React.FC<VersusBuzzerProps> = ({
  team,
  activeTeam,
  onBuzz,
  id,
  className = '',
}) => {
  const isSelfActive = activeTeam === team;
  const isOtherActive = activeTeam !== null && activeTeam !== team;

  return (
    <button
      type="button"
      id={id || `btn-buzz-${team}`}
      className={`versus-buzzer-btn buzzer-${team} ${isSelfActive ? 'buzzer-active' : ''} ${
        isOtherActive ? 'buzzer-locked' : ''
      } ${className}`}
      onClick={() => onBuzz(team)}
      disabled={activeTeam !== null}
      aria-label={`Buzz in ${team === 'blue' ? 'Blue' : 'Red'} Team`}
    />
  );
};

interface VersusBuzzerPairProps {
  activeTeam: VersusTeam | null;
  onBuzz: (team: VersusTeam) => void;
  position: 'top' | 'bottom';
}

export const VersusBuzzerPair: React.FC<VersusBuzzerPairProps> = ({
  activeTeam,
  onBuzz,
  position,
}) => {
  return (
    <div className={`versus-buzzer-pair versus-buzzer-pair-${position}`}>
      <VersusBuzzer
        team="blue"
        activeTeam={activeTeam}
        onBuzz={onBuzz}
        id={`btn-buzz-blue-${position}`}
        className="buzzer-half-left"
      />
      <VersusBuzzer
        team="red"
        activeTeam={activeTeam}
        onBuzz={onBuzz}
        id={`btn-buzz-red-${position}`}
        className="buzzer-half-right"
      />
    </div>
  );
};

